export const linkData = [
  {
    id: 0,
    to: "/games/tenzies",
    title: "Tenzies",
    isActive: false,
  },
  {
    id: 1,
    to: "/games/rock-paper-scissors",
    title: "Rock Paper Scissors",
    isActive: false,
  },
];
